import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { BaseComponent } from '../base-component';
import { MenuService } from '../menu/services/menu.service';
import { SubMenuComponent } from '../menu/sub-menu/sub-menu.component';

@Component({
  selector: 'app-main',
  imports: [RouterOutlet, SubMenuComponent],
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent extends BaseComponent {
  public readonly menuService = inject(MenuService);
  private readonly router = inject(Router);

  protected get isMinimalLayoutPage(): boolean {
    return this.router.url === this.appRoutes.Welcome || this.router.url.startsWith(this.appRoutes.Auth.root);
  }
}
